(function () {
  var MOBILE_QUERY = '(max-width: 749px)';

  function findBundle() {
    // Move the whole wrapper you already have
    return document.querySelector('.bundles--top');
  }

  function findTarget() {
    // The anchor you added under the specs table
    return document.getElementById('mobile-bundle-target');
  }

  function moveOnce() {
    if (!window.matchMedia(MOBILE_QUERY).matches) return;
    var bundle = findBundle();
    var target = findTarget();
    if (bundle && target && bundle.parentNode !== target) {
      target.appendChild(bundle);
    }
  }

  // Run when ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', moveOnce);
  } else {
    moveOnce();
  }

  // If the app initializes late, try a few times + watch DOM changes
  var tries = 0, t = setInterval(function () {
    moveOnce();
    if (++tries > 30) clearInterval(t);
  }, 100);

  var obs = new MutationObserver(moveOnce);
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();
